export const PIXEL_RATIO = window.devicePixelRatio || 1
export const VIEWPORT_RATIO = 0.98
export const NIF_LETTERS = 'TRWAGMYFPDXBNJZSQVHLCKE'
export const CIF_LETTERS = 'JABCDEFGHI'
export const NIE_PREFIX = { X: '0', Y: '1', Z: '2' }
// export const TiposHistorico = ['notificacion', 'usuario', 'cifempresa']
